import { createAppI18n, sharedTranslations, type TKeyOf } from '@repo/i18n'
import { authTranslations } from '@/routes/(auth)/-translations/auth-translations'
import { adminsTranslations } from '@/routes/(private)/admins/-translations/admins-translations'
/**
 * App-owned i18n facade. The engine and the shared `shared` namespace (text
 * built into `@repo/ui` components) live in `@repo/i18n`; the app's own
 * `common` namespace and feature namespaces live here. App code keeps importing
 * from `@/lib/i18n`.
 */
import { poTranslations } from '@/routes/(private)/documents/-translations/po-translations'
import { esclusiveTranslations } from '@/routes/(private)/esclusive/-translations/esclusive-translations'
import { profileTranslations } from '@/routes/(private)/profile/-translations/profile-translations'
import { commonTranslations } from '@/translations/common-translations'

const resources = {
	en: {
		common: commonTranslations.en,
		shared: sharedTranslations.en,
		'admin-admins': adminsTranslations.en,
		esclusive: esclusiveTranslations.en,
		po: poTranslations.en,
		auth: authTranslations.en,
		profile: profileTranslations.en
	},
	it: {
		common: commonTranslations.it,
		shared: sharedTranslations.it,
		'admin-admins': adminsTranslations.it,
		esclusive: esclusiveTranslations.it,
		po: poTranslations.it,
		auth: authTranslations.it,
		profile: profileTranslations.it
	}
} as const

const appI18n = createAppI18n(resources, { defaultNS: 'common' })

export const { useTranslation, Trans, translateApp } = appI18n

/**
 * All translation keys with namespace prefix (e.g.
 * `shared:http_errors.default`).
 */
export type TKey = TKeyOf<(typeof resources)['it']>

// Every browser tab reads «Nome pagina - Gustav AI»: a route passes the page
// name and the brand is appended here, once.
export const APP_NAME = 'Gustav AI'

export function pageTitle(name: string) {
	return `${name} - ${APP_NAME}`
}

const i18n = appI18n.i18n

export default i18n

export { type AppLanguageCode, getInitialAppLanguage } from '@repo/i18n'
